export const GET_ESCALATION_SUPPORT_DATA_REQUEST = 'GET_ESCALATION_SUPPORT_DATA_REQUEST';
export const GET_ESCALATION_SUPPORT_DATA_SUCCESS = 'GET_ESCALATION_SUPPORT_DATA_SUCCESS';
export const GET_ESCALATION_SUPPORT_DATA_FAILURE = 'GET_ESCALATION_SUPPORT_DATA_FAILURE';
